import React, { Component } from 'react';
import _ from 'lodash';

// Components
import ResizablePanelsResizer from './ResizablePanelsResizer';

export default class ResizablePanels extends Component {
  constructor(props) {
    super(props);

    this.resizable = React.createRef();
    this.state = {
      panelsSize: [],
      resizing: false
    };
  }

  componentDidMount() {
    this.setState({ ...this.state, panelsSize: this.props.panelsSize });

    document.addEventListener('mousemove', this.executeResize);
    document.addEventListener('mouseup', this.onMouseUp);
  }

  componentWillUnount() {
    document.removeEventListener('mousemove', this.executeResize);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  render() {
    const { bkcolor } = this.props;
    const rest =
      this.props.children.length > 1 ? this.props.children.slice(1) : [];

    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height,
          background: bkcolor,
          display: 'flex',
          flexDirection: this.props.displayDirection || 'row'
        }}
        ref={this.resizable}
      >
        {this.renderFirst()}
        {this.renderRest(rest)}
      </div>
    );
  }

  renderFirst() {
    return this.renderChildren(this.props.children[0], 0);
  }

  renderRest(rest) {
    return [].concat(
      ...rest.map((children, index) => {
        return [
          this.renderResizer(index + 1),
          this.renderChildren(children, index + 1)
        ];
      })
    );
  }

  renderChildren(children, index) {
    return (
      <div
        className="resizable-fragment"
        key={`fragment_` + index}
        style={this.getStyle(index)}
      >
        {children}
      </div>
    );
  }

  renderResizer(index) {
    return (
      <ResizablePanelsResizer
        size={this.props.resizerSize || '10px'}
        key={`resizer_` + index}
        direction={this.props.displayDirection}
        onMouseDown={e => this.startResize(e, index)}
        color={this.props.resizerColor}
        borderTopColor={this.props.resizerBorderTopColor}
        borderBottomColor={this.props.resizerBorderBottomColor}
        borderLeftColor={this.props.resizerBorderLeftColor}
        borderRightColor={this.props.resizerBorderRightColor}
      />
    );
  }

  displayDirectionIsColumn() {
    return this.props.displayDirection === 'column' ? true : false;
  }

  getStyle(index) {
    const panelsSize = this.state.panelsSize || [];
    const panelsSizeLength = panelsSize.length - 1;
    const size = index > panelsSizeLength ? '100%' : panelsSize[index];
    const unitMeasure = this.props.sizeUnitMeasure || 'px';

    if (this.displayDirectionIsColumn()) {
      return {
        height: `${size}${unitMeasure}`,
        width: `100%`,
        overflow: 'hidden'
      };
    }

    return {
      height: `100%`,
      width: `${size}${unitMeasure}`,
      overflow: 'hidden'
    };
  }

  startResize(e, index) {
    e.preventDefault();
    this.setState({
      ...this.state,
      resizing: true,
      currentPanel: index,
      initialPos: this.displayDirectionIsColumn() ? e.clientY : e.clientX
    });
  }

  executeResize = (e) => {
    if (this.state.resizing) {
      const currentMousePosition = this.displayDirectionIsColumn()
        ? e.clientY
        : e.clientX;

      const displacement = this.state.initialPos - currentMousePosition;

      const nextPanelsSize = this.getNextPanelsSize(displacement);

      const usePercentage = this.props.sizeUnitMeasure === '%';
      const componentSize = this.getCurrentComponentSize();

      let nextPanelsSizeInPx = nextPanelsSize;

      if (usePercentage) {
        nextPanelsSizeInPx = nextPanelsSize.map(panelSize => {
          return panelSize * componentSize / 100;
        });
      }

      for (let i = 0; i < nextPanelsSizeInPx.length; i++) {
        if (this.props.onChangePanelSizeCb && this.props.onChangePanelSizeCb[i]) {
          this.props.onChangePanelSizeCb[i]({ width: nextPanelsSizeInPx[i] });
        }
      }
      this.setState({
        ...this.state,
        initialPos: currentMousePosition,
        panelsSize: nextPanelsSize,
        displacement
      });
    }
  }

  onMouseUp = () => {
    this.stopResize();
  }

  stopResize = () => {
    this.setState({
      ...this.state,
      resizing: false,
      currentPanel: null,
      displacement: 0
    });
  };

  getCurrentComponentSize() {
    const componentSizes = this.resizable.current.getBoundingClientRect();

    return this.displayDirectionIsColumn()
      ? componentSizes.height
      : componentSizes.width;
  }

  getNextPanelsSize(displacement) {
    const currentPanelsSize = this.state.panelsSize;
    const usePercentage = this.props.sizeUnitMeasure === '%';



    const resizeSize = usePercentage
      ? this.convertToPercentage(displacement)
      : displacement;

    const curPanelInd = this.state.currentPanel;
    // console.info('=== ', curPanelInd, resizeSize <= 0 ? 'inc' : 'dec');
    const increasing = resizeSize <= 0;

    const newPanelsSize = currentPanelsSize.map((panelSize, index) => {

      if (increasing) {

        if (curPanelInd === 1) {
          if (index === 0) {
            return this.getVal(panelSize - resizeSize);
          }
          if (index === 1) {
            return this.getVal(panelSize + resizeSize);
          }
          if (index === 2) {
            if (currentPanelsSize[1] === 0 && currentPanelsSize[2] !== 0) {
              return this.getVal(panelSize + resizeSize);
            }
            return panelSize;
          }
        }

        if (curPanelInd === 2) {
          if (index === 1) {
            if (currentPanelsSize[2] > 0) {
              return this.getVal(panelSize - resizeSize);
            }
          }
          if (index === 2) {
            return this.getVal(panelSize + resizeSize);
          }
        }

      } else {
        if (curPanelInd === 1) {
          if (index === 0) {
            return this.getVal(panelSize - resizeSize);
          }
          if (index === 1) {
            if (currentPanelsSize[0] > 0) {
              return this.getVal(panelSize + resizeSize);
            }
          }
        }

        if (curPanelInd === 2) {
          if (index === 0 && currentPanelsSize[1] === 0) {
            return this.getVal(panelSize - resizeSize);
          }
          if (index === 1) {
            return this.getVal(panelSize - resizeSize);
          }
          if (index === 2) {
            return this.getVal(panelSize + resizeSize);
          }
        }
      }

      return panelSize;
    });

    // console.info('=== ', newPanelsSize, newPanelsSize.reduce((pre, curr) => pre + curr, 0));

    return newPanelsSize;
  }

  getVal = (val) => {
    return val >= 0 ? (val > 100 ? 100 : val) : 0;
  }

  convertToPercentage(displacement) {
    const size = this.getCurrentComponentSize();

    return (displacement * 100) / size;
  }
}
